// extracted by mini-css-extract-plugin
module.exports = {"links":"_1c9529d521--links--kt1bo","link":"_1c9529d521--link--TWc7K"};